import { render } from "./beautifyMod.vue?vue&type=template&id=76a64ab9&scoped=true"
import script from "./beautifyMod.vue?vue&type=script&lang=js"
export * from "./beautifyMod.vue?vue&type=script&lang=js"

import "./beautifyMod.vue?vue&type=style&index=0&id=76a64ab9&scoped=true&lang=css"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a64ab9"]])

export default __exports__